/* ============================================================
   Sam's Store — Parallax Hero JS (Phase C)
   Desktop only. Hero image moves at 30% of scroll speed
   creating a luxury depth illusion.
   Uses CSS custom property --sam-parallax-y for performance
   (avoids layout thrash, only triggers composite layer).
   ============================================================ */
(function () {
  'use strict';

  /* Disable on mobile — performance and iOS issues */
  if (window.matchMedia('(max-width: 749px)').matches) return;

  /* Disable if user prefers reduced motion */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Find the first banner media element on the page */
  var bannerMedia = document.querySelector('.banner__media');
  if (!bannerMedia) return;

  /* Ensure parent banner has overflow hidden so parallax image
     moving out of bounds gets clipped cleanly */
  var banner = bannerMedia.closest('.banner');
  if (banner) {
    banner.style.overflow = 'hidden';
  }

  /* Set will-change for GPU compositing */
  bannerMedia.style.willChange = 'transform';
  bannerMedia.style.transition = 'none';

  var ticking = false;
  var bannerBottom = 0;

  function getBannerBottom() {
    if (banner) {
      bannerBottom = banner.getBoundingClientRect().bottom + window.scrollY;
    }
  }

  function applyParallax() {
    var scrollY = window.scrollY;

    /* Only apply when banner is in view */
    if (scrollY < bannerBottom) {
      /* Move image at 30% of scroll speed */
      var offset = scrollY * 0.30;
      bannerMedia.style.transform = 'translateY(' + offset + 'px)';
    }

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(applyParallax);
      ticking = true;
    }
  }, { passive: true });

  /* Recalculate on resize */
  window.addEventListener('resize', function () {
    getBannerBottom();
    applyParallax();
  }, { passive: true });

  /* Init */
  getBannerBottom();
  applyParallax();
})();
